module.exports = __webpack_public_path__ + "img/header-weddingRingsTwoColors.c07d0fe.webp";